import { generateUrl } from 'utils/helpers';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const hospitalList = () =>
  apiLoaderInstance.get(URL.GET_VETSPIRE_HOSPITAL_LIST);

export const getAppointmentTypes = (hospitalId: number) =>
  apiLoaderInstance.get(
    generateUrl(URL.GET_VETSPIRE_APPOINTMENT_TYPES, {
      hospital_id: hospitalId,
    })
  );
